/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCarveOutQuoteRequest
 */
export interface AddCarveOutQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCarveOutQuoteRequest
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof AddCarveOutQuoteRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddCarveOutQuoteRequest
     */
    content_type?: string;
}

/**
 * Check if a given object implements the AddCarveOutQuoteRequest interface.
 */
export function instanceOfAddCarveOutQuoteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AddCarveOutQuoteRequestFromJSON(json: any): AddCarveOutQuoteRequest {
    return AddCarveOutQuoteRequestFromJSONTyped(json, false);
}

export function AddCarveOutQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCarveOutQuoteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        's3_key': json['s3_key'],
        'name': json['name'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
    };
}

export function AddCarveOutQuoteRequestToJSON(value?: AddCarveOutQuoteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3_key': value.s3_key,
        'name': value.name,
        'content_type': value.content_type,
    };
}

